import React, { Component, Fragment, useEffect, useState } from 'react';
import Configurator from "../../Components/ProductPage/Configurator";
import SuperBuilder from '../../Components/ProductPage/SuperBuilder';
import BuySection from '../../Components/ProductPage/BuySection';
import { translate } from '../../Services/translation';
import MultiCarousel from '../MultiCarousel';
import LightboxImages from '../../Components/ProductPage/LightboxImages';
import { load as loadCart, hint as hintCart } from '../../Actions/Cart.action';
import StringBuilder from '../../Components/StringBuilder';
import FavoriteIcon from '../../Components/FavoriteIcon';
import ProductInformation from './ProductInformation';
import BrandInfo from './BrandInfo';
import MultiCarouselProduct from '../MultiCarouselProduct';
import { culture } from '../../Services/culture';
import SliderImages from './SliderImages';
import { useDispatch } from 'react-redux';
import { pushProductPageEvent } from '../../Actions/Gtm.action';

const Product = (props) => {
    const dispatch = useDispatch();
        

    const [product, setProduct] = useState([]);
    const [imageItems, setimageItems] = useState([]);
    const [productFieldValue, setproductFieldValue] = useState([]);
    const [isSuperBuilderActive, setisSuperBuilderActive] = useState(false);
    const [isConfiguratorActive, setisConfiguratorActive] = useState(false);
    const [selectedKeys, setselectedKeys] = useState([]);
    const [quantity, setquantity] = useState(0);
    const [selectedOptions, setselectedOptions] = useState([]);   
    const [reloadChildComponent, setreloadChildComponent] = useState(false);
    const [reloadConfigurator, setreloadConfigurator] = useState(false);

    let productInformationVisible = false;
    let productSpecificationVisible = false;
    let productOthersVisible = false;
    let images = [];
    let optionNames = props.optionNames;


    let campaignClass = "product-detail__campaign-label";    


    // Set initial mandatory section id for scroll    

    const getNonSelectedMandatorySectionId = (sections) => {
        const mandatorySections = sections.filter(x => x.isMandatory);
        if (mandatorySections) {
            const mandatorySectionWithNoSelection = mandatorySections.find(section => section.userSelected === false);
            return mandatorySectionWithNoSelection ? mandatorySectionWithNoSelection.id : "";
        }
    }

    useEffect(() => {
        setProduct(props.product);          
    }, []);

    useEffect(() => {             
        if (props.superBuilderJsonData == undefined) {
            return;
        }

        if (props.selectedCombinedConfiguratorKeys) {
            updatePriceBetweenComponenets(props.selectedCombinedConfiguratorKeys, true)
        }
    }, [props]);

    useEffect(() => {
        if (product && product?.productItem?.id) {
            GetProductImageUrls();
            setproductFieldValue(product.productFieldValue);
            dispatch(pushProductPageEvent(product.productItem.id));


            let superBuilderHasData = product.superBuilderJsonData != null && props.product.superBuilderJsonData != "";
            let superBuilderHasSections = superBuilderHasData ? JSON.parse(props.product.superBuilderJsonData).sections.length > 0 : false;

            let configuratorHasData = props.product.productConfiguratorJsonData != null && props.product.productConfiguratorJsonData != "";
            let configuratorHasSections = configuratorHasData ? JSON.parse(props.product.productConfiguratorJsonData).sections.length > 0 : false;

            if (configuratorHasSections && superBuilderHasSections) {
                let superBuilderData = JSON.parse(product.superBuilderJsonData);
                let nonSelectedMandatorySectionId = getNonSelectedMandatorySectionId(superBuilderData.sections);
        
                let configData = JSON.parse(product.productConfiguratorJsonData);
                configData.nonMandatorySectionNotSelectedId = nonSelectedMandatorySectionId;
                props.product.productConfiguratorJsonData = JSON.stringify(configData);
            }

            setquantity(product.packagingQuantity);
            setisConfiguratorActive(configuratorHasSections);
            setisSuperBuilderActive(superBuilderHasSections);            

            // if (superBuilderHasSections) {
            //     props.product.campaignPrice = 0;
            //     props.product.price = 0;
            // }
        }
    }, [product]);

    useEffect(() => {
        setreloadChildComponent(!reloadChildComponent);
    }, [quantity]);


    const updatePriceBetweenComponenets = (selectedCombinedKeys, updateSB, firstIteration, selectedOptions, quantity, nonMandatorySectionNotSelectedId, quantityUpdate = false) => {
        if (updateSB) {
            if (selectedCombinedKeys == null) {
                setquantity(quantity);                
                return;
            }
            var superBuilderData = JSON.parse(product.superBuilderJsonData);

            superBuilderData.sections.forEach(s =>
                s.variants.forEach((v) => {
                    for (var i = 0; i < selectedCombinedKeys.length; i++) {
                        if (selectedCombinedKeys[i].key === v.key) {
                            v.selected = true;
                            v.quantity = selectedCombinedKeys[i].quantity;
                        }
                    }
                }));

            let index = 0;
            var configData = JSON.parse(product.productConfiguratorJsonData);
            configData.sections.forEach(section => {
                section.options.forEach(o => {
                    for (var i = 0; i < selectedCombinedKeys.length; i++) {
                        if (selectedCombinedKeys[i].value.includes(o.key) && selectedOptions && selectedOptions.includes(getSelectedOptionName(o))
                            && selectedOptions.length !== index) {
                            o.selected = true;
                            index++;
                        }
                        else {
                            o.selected = false;
                        }
                    }
                });
            });

            superBuilderData.selectedCombinedKeys = selectedCombinedKeys;
            let tempProductData = product;

            tempProductData.superBuilderJsonData = JSON.stringify(superBuilderData);
            setselectedOptions(selectedOptions);
            setProduct(tempProductData);
        }
        else {
            if (product.productConfiguratorJsonData && product.productConfiguratorJsonData !== "") {
                var configData = JSON.parse(product.productConfiguratorJsonData);
                selectedOptions = selectedOptions;

                configData.sections.forEach(s => {
                    s.options.forEach((o) => {
                        if (firstIteration) {
                            o.selected = true;
                            firstIteration = false;
                            if (o.key != null) {
                                for (var i = 0; i < selectedCombinedKeys.length; i++) {
                                    selectedCombinedKeys[i].value.push(o.key);
                                }
                            }
                        }
                        else if (selectedOptions && selectedOptions.includes(getSelectedOptionName(o))) {
                            o.selected = true;
                            s.userSelected = true;
                        }
                        else {
                            o.selected = false;
                        }
                    });
                }
                );

                if (nonMandatorySectionNotSelectedId && nonMandatorySectionNotSelectedId !== "") {
                    configData.nonMandatorySectionNotSelectedId = nonMandatorySectionNotSelectedId;
                }

                configData.selectedCombinedKeys = selectedCombinedKeys;
                let tempProductData = product;
                tempProductData.productConfiguratorJsonData = JSON.stringify(configData);
                setProduct(tempProductData);
            }
            else {
                var superBuilderData = JSON.parse(product.superBuilderJsonData);
                superBuilderData.selectedCombinedKeys = selectedCombinedKeys;

                let tempProductData = product;
                tempProductData.superBuilderJsonData = JSON.stringify(superBuilderData);
                setProduct(tempProductData);
                selectedOptions = selectedCombinedKeys;
            }

            if (!quantityUpdate) {
                setreloadConfigurator(!reloadConfigurator);
            }            
        }        
    }

    const getSelectedOptionName = (option) => {
        if (option) {
            if (option.additionalInfo && option.additionalInfo.row2) {
                return `${option.name} -  ${option.additionalInfo.row2}`;
            }
            else {
                return option.name;
            }
        }
    }

    const GetFilterItem = (item, uniqueImages) => {
        return (
            <li key={item.id}>
                {item.variantImage != null && uniqueImages &&
                    <a onClick={() => ChangeProduct(item.id, item.sEOTitle, item.title)} className={item.enabled ? "" : "unavailable" + " configurator-variants__img-container"}
                        dangerouslySetInnerHTML={{ __html: item.variantImageUrl }} />
                }
                <div className="configurator-variants__name-container">
                    <a onClick={() => ChangeProduct(item.id, item.sEOTitle, item.title)} className={"config-check " + (item.isActive ? " config-check--checked" : "") + (!item.enabled ? " config-check--disabled" : "")}>
                        {item.isActive &&
                            <svg>
                                <use href="/ui/images/tibergs-svg/sprite/sprite.svg#checked"></use>
                            </svg>
                        }
                    </a>
                    <div className="configurator-variants__info">
                        <a onClick={() => ChangeProduct(item.id, item.sEOTitle, item.title)} className="configurator-variants__name">{item.title}</a>
                        <div className="configurator-variants__price-container">
                            {item.priceOriginalFormatted &&
                                <div className="configurator-variants__original-price">
                                    {item.configuratorPrefix} {item.priceOriginalFormatted}
                                </div>
                            }
                            {item.priceFormatted != null && item.priceFormatted != "" &&
                                <div className="configurator-variants__price">
                                    {item.configuratorPrefix} {item.priceFormatted}
                                </div>
                            }
                        </div>

                    </div>
                </div>
            </li>
        )
    }

    const GetProductImageUrls = () => {
        var imageItemsData = product.productItem.lightBoxLazyLoadImagesUrl;

        if (product.productItem.youTubeLink != null && product.productItem.youTubeLink != "") {
            let thumbnailItemYoutube = {
                "src": "/ui/images/tibergs-svg/play.svg"
            };
            let itemsYoutube = {
                "src": product.productItem.youTubeLink,
                "iframe": 'true',
                "view360": 'false',
                "thumbnail": thumbnailItemYoutube
            };
            imageItemsData.push(itemsYoutube);
        }

        setimageItems(imageItemsData);
    }

    const ChangeProduct = (Id, seotitle, title) => {
        fetch("/api/product/getselectedproduct?variantId=" + Id + "&isMobile=" + product.isMobileDevice, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'litium-request-context': JSON.stringify(__litium.requestContext)
            },
            redirect: 'follow'
        })
            .then(response => response.json())
            .then(result => {
                if (result != null) {
                    var productModel = result;
                    document.title = translate('seotitle.productpage').replace("{Product name}", seotitle ? seotitle : title).replace("{Product brand}", product.productItem.brand);
                    setProduct(productModel);
                    GetProductImageUrls();
                    setProductFieldValue(productModel.productFieldValue);
                }
            })
            .catch(error => console.log('error', error));
    }

    const loadCart = (data) => {
        dispatch(loadCart(data));
    }

    const hintAddedItem = (articleNumber) => {
        dispatch(hintCart(true, articleNumber))
        setTimeout(() => {
            dispatch(hintCart(false, articleNumber))
        }, 2000);
    }


    return (
        <Fragment>
            {product && product?.productItem?.id && <>
                <div className="product-detail" itemScope itemType="http://schema.org/Product">
                    <div className="product-detail__inner">
                        <meta itemProp="gtin13" content={product.GTIN}></meta>

                        <div className="product-detail__header-container">
                            <h1 className="product-detail__name as-h2" itemProp="name">{product.productItem.name}</h1>
                            <FavoriteIcon articleNumber={product.productItem.baseProductId != "" ? product.productItem.baseProductId : product.productItem.id}></FavoriteIcon>
                            {product.productItem.brand && product.brandPage &&
                                <div className="product-detail__brand">
                                    {translate('product.brand')}: <a href={product.brandPage.brandUrl}> <span>{product.productItem.brand}</span></a>
                                    <meta itemProp="brand" content={product.productItem.brand}></meta>
                                </div>

                            }
                        </div>

                        <div className="product-detail__images">
                            <div className="product-detail__image-gallery">
                                {product.productItem.newsSvg != null && product.productItem.newsSvg != ""
                                    && product.productItem.labelImageNewsUrl
                                    ? <img className={`${campaignClass}`} src={product.productItem.labelImageNewsUrl} />
                                    :
                                    product.productItem.campaignSvg != null && product.productItem.campaignSvg != "" &&
                                        product.productItem.campaignSvg != "campaign" ?
                                        <img className={`${campaignClass}`} src={product.productItem.campaignSvg} />
                                        : product.productItem.campaignSvg == "campaign" && !product.productItem.newsSvg
                                        && product.productItem.labelImageCampaignUrl
                                        && (product.productItem.campaignPercentage ?
                                            <div className={`${campaignClass} product-detail__campaign-percentage`}
                                                style={{
                                                    color: product.productItem.campaignPercentageColor,
                                                    backgroundColor: product.productItem.campaignPercentageBackgroundColor
                                                }}>
                                                {product.productItem.campaignPercentage}%</div> :
                                            <img className={`${campaignClass}`} src={product.productItem.labelImageCampaignUrl} />)
                                }
                                {((product.productItem.charpter3DLinkIOS !== null && product.productItem.charpter3DLinkIOS !== "")
                                    || (product.productItem.charpter3DLinkAndroid !== null && product.productItem.charpter3DLinkAndroid !== "")) &&
                                    <div className={(product.productItem.newsSvg !== null && product.productItem.newsSvg !== "")
                                        || (product.productItem.campaignSvg !== null && product.productItem.campaignSvg !== "")
                                        ? "product-detail__charpster-container" : "product-detail__charpster-container-top"}>
                                        <charpstar-container data-language="sv-se" data-position="bottom-right" style={{ display: 'none' }}>
                                            <button data-tech="charpstar-ar">{translate("product.charpstar.viewinAR")}</button>
                                            <button data-tech="charpstar-3d">{translate("product.charpstar.viewin3D")}</button>
                                        </charpstar-container>
                                    </div>
                                }
                                {product.productItem.images != null && product.productItem.images.length > 0 ?
                                    <div>
                                        <LightboxImages images={imageItems} isAmbiance={product.productItem.adjustEnvironmentalImageBackground}
                                            thumbnails={imageItems.map((item) => (item.thumbnail))}></LightboxImages>
                                    </div> : <span className="product-detail__image-missing">{translate('product.noproductimage')}</span>}
                            </div>
                            {product.productItem != null && product.productItem.additionalImages != null && product.productItem.additionalImages.length > 0 &&
                                <div className="product-detail__additional-images">
                                    {product.productItem.additionalImagesUrl.map((item, index) => (
                                        <div dangerouslySetInnerHTML={{ __html: item }} key={index} />))}
                                </div>}
                        </div>
                        <input type="hidden" id="hdnItemUrl" value={product.productItem.urlFieldData} />




                        <div className={'product-detail__product-selector' + (product.productInfoMessage ? ' has-message' : '')}>

                            <div className="product-detail__product-description">

                                {product.productItem.productDescription &&
                                    <div itemProp="description" className="product-detail__description" dangerouslySetInnerHTML={{ __html: product.productItem.productDescription }} />
                                }

                                {product.productItem.productPriceItem.priceModel.price != null && product.productItem.productPriceItem.priceModel.price != null &&
                                    <meta itemProp="sku" content={product.productItem.productPriceItem.priceModel.price.unitOfMeasurementTitle} />
                                }
                            </div>
                            <div className="product-detail__select-and-buy">


                                {product.superBuilderJsonData !== null && product.superBuilderJsonData !== "" ?
                                    <SuperBuilder key={product.selectedVariant.id + reloadChildComponent} parent={product.selectedVariant} superBuilder={product.superBuilderJsonData}
                                        prices={product.productConfiguratorPricesJsonData} comment={product.comment} updatePrice={updatePriceBetweenComponenets}
                                        quantity={Number(quantity)} isConfiguratorActive={isConfiguratorActive} />
                                    :
                                    <ul className={"product-selector " + (product.productConfiguratorJsonData != null && product.productConfiguratorJsonData != "" ? " product-selector--variant-select" : "")}>
                                        {product.colors != null && product.colors.length > 1 &&
                                            <li key={product.colorText}>
                                                <div className="product-selector__header">
                                                    <div className="section-status section-status--done">
                                                        <svg>
                                                            <use href="/ui/images/tibergs-svg/sprite/sprite.svg#checked"></use>
                                                        </svg>
                                                    </div>
                                                    <div className="product-selector__name">
                                                        <span>{product.colorText}</span>
                                                    </div>
                                                </div>
                                                <div className="product-selector__content">
                                                    <ul className="configurator-variants" data-filter="colorfilter" id="colorfilter">
                                                        {product.colors.map((color) => (GetFilterItem(color, product.uniqueImage)))}
                                                    </ul>
                                                </div>
                                            </li>
                                        }
                                        {product.sizes != null && product.sizes.length > 1 &&
                                            <li key={product.sizeText}>
                                                <div className="product-selector__header">
                                                    <div className="section-status section-status--done">
                                                        <svg>
                                                            <use href="/ui/images/tibergs-svg/sprite/sprite.svg#checked"></use>
                                                        </svg>
                                                    </div>
                                                    <div className="product-selector__name">
                                                        <span>{product.sizeText}</span>
                                                    </div>
                                                </div>
                                                <div className="product-selector__content">
                                                    <ul className="configurator-variants" data-filter="sizefilter" id="sizefilter">
                                                        {product.sizes.map((size) => (GetFilterItem(size, false)))}
                                                    </ul>
                                                </div>
                                            </li>}
                                    </ul>
                                }

                                {product.productConfiguratorJsonData != null && product.productConfiguratorJsonData != "" ?
                                    <Configurator key={product.selectedVariant.id + reloadConfigurator} parent={product.selectedVariant} configurator={product.productConfiguratorJsonData}
                                        prices={product.productConfiguratorPricesJsonData} stockstatus={product.stockStatusJsonData}
                                        stockInfoMessage={product.stockInfoMessage} comment={product.comment}
                                        packagingQuantity={Number(product.packagingQuantity)}
                                        featureList={product.featureList} productInfoMessage={product.productInfoMessage} updatePrice={updatePriceBetweenComponenets}
                                        isSuperBuilderActive={isSuperBuilderActive} />
                                    :
                                    <BuySection title={product.recommendedAccessoriesTitle} article={product.productItem.id} price={product.price}
                                        campaignPrice={product.campaignPrice} stockstatus={JSON.parse(product.stockStatusJsonData)}
                                        accessories={product.recommendedAccessories.value} comment={product.comment}
                                        stockInfoMessage={product.stockInfoMessage} packagingQuantity={Number(product.packagingQuantity)}
                                        productInfoMessage={product.productInfoMessage} bundleProducts={JSON.parse(product.bundleProductsList)}
                                        featureList={product.featureList} hintAddedItem={hintAddedItem} loadCart={loadCart}
                                        parent={product.selectedVariant} superBuilder={product.superBuilderJsonData} />
                                }

                            </div>
                        </div>
                    </div>
                </div>

                <ProductInformation
                    informationTemplate={product.informationTemplate}
                    productFieldValue={productFieldValue}
                    detailedSpecification={product.detailedSpecification}
                />

                {
                    product.stringBuilderGuid !== null && product.stringBuilderGuid !== "" && product.brandPage !== null &&
                    <div id="string-builder">
                        <StringBuilder guid={product.stringBuilderGuid} stringImageHtml={product.brandPage.stringImageHtml}
                            textColor={product.brandPage.textColor} />
                    </div>
                }

                {
                    product.mostSoldProducts != null && product.mostSoldProducts.length > 1 &&
                    <div className="row">
                        <div className="small-12 columns">

                            {product.productItem.name != null && product.productItem.name != "" &&
                                <h2 className="product-detail__header-title" dangerouslySetInnerHTML={{ __html: translate("product.popularproducts") + "<span className='highlight'> " + product.productItem.name + "</span>" }}>
                                </h2>
                            }
                            {(product.productItem.name == null || product.productItem.name == "") &&
                                <h2 className="product-detail__header-title">{translate('product.mostsoldproducts')}</h2>
                            }


                            <div className="row most-sold-container">
                                {product.mostSoldProducts.map((item, index) => {
                                    return (
                                        <div key={index} className="product-list__item columns small-6 medium-4 large-3">
                                            <MultiCarouselProduct item={item} index={index} />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                }

                {
                    product.accessoriesProducts != null && product.accessoriesProducts.value.length > 0 &&
                    <section className="row-container bg--beige no-print">
                        <div className="row bg-padding">
                            <div className="small-12 columns">
                                <div>

                                    <h3 className="product-detail__header-pre-title pre-header-list">{translate('common.selectedforyou')}</h3>
                                    <h2 className="product-detail__header-title header-list">
                                        {product.accessoriesProducts.key.fields._name[culture]}
                                    </h2>
                                    <div className="product-detail__item-container">
                                        <div className="row multi-carousel-style">
                                            <MultiCarousel items={JSON.parse(product.similarProductsJson)} itemType="product" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                }

                {
                    product.recommendedProducts && product.recommendedProducts.map((products, index) => (
                        products && products.recommendedProducts &&
                        <Fragment key={`recommendedproducts-${products.id}-${index}`}>
                            <div className="block-container no-print">
                                <div className="row block-heading">
                                    <h2 className="columns small-12 header-list text--center">{products.title}</h2>
                                </div>
                                <div className="row multi-carousel-style">
                                    <MultiCarousel items={(products.recommendedProducts)} itemType="product" />
                                </div>
                            </div>
                        </Fragment>
                    ))
                }

                {product.brandPage != null &&
                    <BrandInfo brandinfo={product.brandPage} />
                }
            </>}
        </Fragment>
    )
}

export default Product;